import React from 'react';
import {connect} from 'react-redux';
import Button from '~/components/common/Button'
import mapDispatch from '~/misc/mapDispatch';
import css from './index.css'
import cs from 'classnames';
import { verifyBidLoads } from '~/modules/loads/actions'
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';

const statusType = {
  BID:"biddable",
  REBID:"PENDING",
  ACCPET:"ACCEPTED",
  REJECTED:"REJECTED",
  EXPIRED:"EXPIRED",
  LOSE:"LOST"
}

const type = {
  [statusType.BID]: {
    color: "Blue",
    text: "Make a Bid",
  },
  [statusType.REBID]: {
    color: "Orange",
    text: "Rebid"
  },
  [statusType.ACCPET]: {
    color: "Green",
    text: "Bid Accepted"
  },
  [statusType.REJECTED]: {
    color: "Red",
    text: 'Bid Rejected'
  },
  [statusType.EXPIRED]: {
    color: "Grey",
    text: "Expired"
  },
  [statusType.LOSE]: {
    color: "Grey",
    text: "Bid Lose"
  },
}

class BidButton extends React.Component {
  constructor(porps) {
    super(porps);
    this.state = {
      status: null
    }
  }
  componentWillMount() {
    this.updateStatus()
  }
  componentWillUpdate() {
    this.updateStatus()
  }
  updateStatus = () => {
    const { shipmentId, bid  } = this.props; 
    const { status, id } = bid.get(shipmentId) || {status: "biddable", id: 0} 
    this.setState({
      id,
      status
    })
  }
  showCreateBid = () => {
    const { showCreateBid, showProfileVerify, shipmentId, curRate, brokerId,brokerName , verifyLoads } = this.props;
    verifyLoads(brokerId).then(res=>{
      const { code, data } = res
      if( code === 200 ) {
        const { status } = data[0];
        if( status ) {
          showCreateBid({
            shipmentId, 
            curRate,
            brokerName,
          })
        }else {
          showProfileVerify()
        }
      }
    })
    
  }
  render() {
    const { status } = this.state;
    const { color, text } = type[status];
    const isBiddable = [statusType.BID, statusType.REBID].includes(status);
    return (
      <Button 
        mods= {["wide", "large"]}
        className = {cs(css.normalize, css['colour'+color])}
        onClick = {()=> { if(isBiddable) this.showCreateBid() }}
      >
        {text}
      </Button>
    )
  }
}

export default connect(({user, bids, loadsSearch}, {loadId,curRate}) => {
  const { map, updated } = bids;
  return {
    shipmentId: loadId,
    userIsLoggedIn: user.isLoggedIn,
    dot: user.dot,
    email: user.email,
    bid: map || new Map(),
    updated,
    curRate
  };
}, mapDispatch({
  verifyLoads: (porps, id) => verifyBidLoads(id),
  showCreateBid: (props, {shipmentId, curRate, brokerName}) => modalChange(modes.CREATE_BID, {type: 'askPop', shipmentId, curRate, brokerName}),
  showProfileVerify: (props) => modalChange(modes.PROFILE_VERIFY, {type: 'askPop'}),
}))(BidButton);



// WEBPACK FOOTER //
// ./src/components/BidButton/index.js